import React, { useState } from 'react';
import styles from './SocketTypeSelectionModal.module.css';

const SocketTypeSelectionModal = ({ isOpen, onClose, onContinue }) => {
  const [selectedType, setSelectedType] = useState('check_socket');

  const socketTypes = [
    {
      id: 'mould',
      name: 'Mould',
      description: 'Base model for initial testing and fit verification',
      image: '/images/mould.webp'
    },
    {
      id: 'check_socket',
      name: 'Check Socket',
      description: 'Trial socket for alignment and comfort assessment',
      image: '/images/check_socket.webp'
    },
    {
      id: 'definitive_socket',
      name: 'Definitive Socket',
      description: 'Final production socket for long-term use',
      image: '/images/definitive_socket.webp'
    }
  ];

  const handleDownloadModel = () => {
    console.log('Download Model clicked for:', selectedType);
    // Add download functionality here
  };

  const handleCancel = () => {
    onClose();
  };

  const handleContinue = () => {
    onContinue(selectedType);
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>Socket Type Selection</h2>
          <p className={styles.instructions}>
            Choose your preferred design variation from the option below
          </p>
        </div>

        {/* Socket Type Options */}
        <div className={styles.optionsContainer}>
          {socketTypes.map((type) => (
            <div
              key={type.id}
              className={`${styles.optionCard} ${
                selectedType === type.id ? styles.selected : ''
              }`}
              onClick={() => setSelectedType(type.id)}
            >
              {/* Selection Indicator */}
              <div className={styles.selectionIndicator}>
                                 {selectedType === type.id ? (
                   <div className={styles.selectedIcon}>
                     <svg width="20" height="20" viewBox="0 0 20 20">
                       <circle cx="10" cy="10" r="9" fill="#7c3aed" />
                       <path
                         d="M8.5 13.5L5 10L5.7 9.3L8.5 12.1L14.3 6.3L15 7L8.5 13.5Z"
                         fill="white"
                       />
                     </svg>
                   </div>
                 ) : (
                   <div className={styles.unselectedIcon}>
                     <svg width="20" height="20" viewBox="0 0 20 20">
                       <circle cx="10" cy="10" r="9" fill="none" stroke="#d1d5db" strokeWidth="2" />
                     </svg>
                   </div>
                 )}
              </div>

              {/* Content */}
              <div className={styles.cardContent}>
                <h3 className={styles.cardTitle}>{type.name}</h3>
                <p className={styles.cardDescription}>{type.description}</p>
                <div className={styles.imageContainer}>
                  <img
                    src={type.image}
                    alt={type.name}
                    className={styles.socketImage}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'block';
                    }}
                  />
                  <div className={styles.imagePlaceholder} style={{ display: 'none' }}>
                    <div className={styles.placeholderContent}>
                      <div className={styles.placeholderIcon}>📦</div>
                      <span>3D Model</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Action Buttons */}
        <div className={styles.actionButtonGroup}>
          <button
            className={styles.downloadButton}
            onClick={handleDownloadModel}
          >
            Download Model
          </button>
          <div className={styles.actionButtons}>
            <button
              className={styles.cancelButton}
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              className={styles.continueButton}
              onClick={handleContinue}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocketTypeSelectionModal; 